import ArtifactProvider from './ArtifactProvider'
import ArtifactSelector from './ArtifactSelector'
import ArtifactDisplay from './ArtifactDisplay'

const integrationArtifactComponents = {
  ArtifactProvider,
  ArtifactSelector,
  ArtifactDisplay
}

export default integrationArtifactComponents
